export default __webpack_public_path__ + "static/media/loans.b012eca4.svg";